<!--
================================================
Un composant affichant une invitation à démarrer une action, affiché lorsqu'une vue est vide.
Par exemple affiche "aucun pointage, démarrez votre premier pointage"

Url d'accès :
http://localhost:8080/fr/cronocloud/projects
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="EmptyViewBlocComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--    {{ 'Hello ! :) I am ' + $options.name }}-->
    <div class="appBloc  is-vcentered" v-bind:id="'blocNo'+emptyItemName" v-show="true">
      <div class="pic">
        <div class="text">
          <span class="main">{{ noItemTitle }}</span>
          <span class="baseline">{{ c2aTxt }}</span>
        </div>
      </div>

    </div>

  </div>

<!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";
    // import _ from 'lodash'

    export default {
        name: 'EmptyViewBlocComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification,
            SentryMixin,
            InterceptorMixin,
            TrackingMixin
        ],
        // components: {},

        props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            emptyItemName: String, // string |  Le nom de l'item qui est vide et que ce composant est censé représenter (ex : "project, timerecord, clients") (sert à générer un attribut html id unique}
            noItemTitle: String, // string | le texte à afficher pour indiquer qu'il n'y a pas d'item (ex : "Aucun pointage,Aucun projet"
            c2aTxt: String, // string | le texte à afficher pour inciter à l'action (ex : "Commencez votre premier pointage"

        },
        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug (ou dispo dans this.$auth.getUserSlug())
                // componentIsReady : false, // indique quand le composant est prêt à être affiché
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay
          }),


            // other computed props :
            // compProp: {
            //     get: function () {return this.foo},
            //     set: function (newValue) {this.foo = newValue}
            // }

        },


        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

        },
      beforeDestroy () {

      },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #EmptyViewBlocComp{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////
        border: dashed 1px #ccc;
        color: $brandFourth;
        font-size: 0.9rem;
        font-weight: bold;
        $height: 7rem;
        min-height: $height;
        line-height: $height;
        vertical-align: middle;
        text-align: center;
        background: #fff;
        margin-bottom: 2rem;
        box-shadow: 2PX 2px 5px #ddd;


        .pic {
          min-height: 14rem;
          margin: 1.5rem auto;
          background-image: url("../assets/img/emptyStatePic/emptyTaskList.png");
          background-position: center;
          background-repeat: no-repeat;

          .text {
            position: relative;
            top: 8rem;
            /*border: solid red;*/
            .main {
              color: $brandSecondary;
              display: block;
              margin-bottom: 0.2rem;
              height: 1rem;
            }

            .baseline {
              color: $brandFourth;

            }
          }

        }



      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
          border-color: lighten($darkBg4, 15%);
          color: $darkTxt;
          background-color: $darkBg4 !important;
          box-shadow: 0 0 5px darken($darkBg4, 5%);

          .appBloc{background-color: transparent !important;}
          .pic {
            background-image: url("../assets/img/emptyStatePic/emptyTaskList-Dark.png");
            @include touch{
              background-size: 60%;
            }

            .text {
              .main {
                color: #eee;
              }
            }
          }


      }

    }
</style>
